<mat-card appearance="outlined">
  <mat-card-content>
    <div class="card-top-section">
      <div class="header-row">
        <header>{{ title }}</header>
        <div class="card-badge">
          <ng-content select="[cardBadge]"></ng-content>
        </div>
      </div>
      <div class="card-description" [laEllipsisTooltip]="description" matTooltip="" matTooltipPosition="above">
        {{ description }}
      </div>
    </div>

    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
